import { Flex } from '@pancakeswap/uikit'
import { motion } from 'framer-motion'

import { CsText } from '../../../../styled'

interface Props {
    isShow: boolean
    content: string[]
}

const Description: React.FC<Props> = ({ isShow, content }) => {
    // ================== VAR ==================
    // ================== STATE ==================
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    // ================== RENDER ==================
    const renderContent = () => {
        return (
            <Flex width="100%" flexDirection="column" style={{ gap: '12px' }}>
                { content?.map((dt) => {
                    return (
                        <CsText>{dt}</CsText>
                    )
                })

                }
            </Flex>
        )
    }
    // ================== MAIN ==================
    if (isShow) {
        return (
            <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.35, ease: 'easeInOut' }}
            >
                {renderContent()}
            </motion.div>
        )
    }
    return (
        <motion.div
            initial={{ opacity: 1, height: 'auto' }}
            animate={{ opacity: 0, height: 0 }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: 'easeInOut' }}
        >
            {renderContent()}
        </motion.div>
    )
}
export default Description
